<div
	*ngIf="showNavigation()"
	class="row columns step-navigation"
	[class.event]="projectType == 'event'"
	[class.shop]="projectType == 'shop'"
	(click)="stepBack()"
  >
	<i class="twingle-arrow_left_solo" aria-hidden="true" role="img"></i>
	<span
		tabindex="0"
		role="button"
		[innerHtml]="(getTextPrefixTextkey() | translate: getPlaceholders()) + ' ' + getText()"
		(keydown.space)="onKeyDownGoBack($event)"
		(keydown.enter)="onKeyDownGoBack($event)"
	></span>
</div>
